import React from "react";
import LastUnitPricesTable from "../../component/UnitPricesTable";
import DownloadMenu from "../../component/DownloadMenu";
import "bootstrap-icons/font/bootstrap-icons.css";

class UnitPricesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            unitPricesData: [],
            errorMessageShow: false,
        };
    }

    componentDidMount() {
        document.title = this.props.pageTitle;
        this.loadUnitPrices();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextState.errorMessageShow !== this.state.errorMessageShow ||
            nextState.unitPricesData !== this.state.unitPricesData
        );
    }

    loadUnitPrices = async () => {
        try {
            const useLocal = process.env.REACT_APP_USE_LOCAL_DATA === "true";
            const localFilePath = this.props.localFilePath;

            let data;

            if (useLocal) {
                console.log("Using local JSON (DEV MODE):", localFilePath);

                const res = await fetch(localFilePath);

                if (!res.ok) {
                    throw new Error(`Failed to load local JSON: ${localFilePath}`);
                }

                data = await res.json();
            } else {
                const params = new URLSearchParams({
                    reportName: this.props.reportName,
                });

                const res = await fetch(`/api/unit-prices?${params.toString()}`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                    mode: "same-origin",
                    cache: "default",
                });
                if (!res.ok) {
                    throw new Error("Failed to load API data");
                }

                data = await res.json();
            }

            if (data.status === "FAILURE" || data.status === "ERROR") {
                this.showError();
                return;
            }

            if (data.status === "SUCCESS") {
                this.setState({
                    unitPricesData: data.data || [],
                    errorMessageShow: false,
                });
                return;
            }

            if (Array.isArray(data)) {
                this.setState({
                    unitPricesData: data,
                    errorMessageShow: false,
                });
                return;
            }

            this.showError();
        } catch (error) {
            console.error("Error loading unit prices:", error);
            this.showError();
        }
    };

    showError = () => {
        this.setState({
            errorMessageShow: true,
            unitPricesData: [],
        });
    };

    getTableData = () => {
        return this.state.unitPricesData.map((item) => ({
            tableHeader: item.heading,
            tableData: item.funds || [],
        }));
    };

    getFormattedDate = () => {
        const formatter = new Intl.DateTimeFormat("en-NZ", {
            timeZone: "Pacific/Auckland",
            year: "numeric",
            month: "long",
            day: "2-digit",
        });

        return formatter.format(new Date());
    };

    renderErrorMessage = () => {
        if (!this.state.errorMessageShow) {
            return null;
        }

        return (
            <div style={{ marginBottom: "30px" }}>
                <div className="alert alert-danger" role="alert" style={{ marginBottom: "0px" }}>
                    <span aria-hidden="true" style={{ marginRight: "8px" }}>
                        <i
                            className="bi bi-exclamation-circle-fill"
                            aria-hidden="true"
                            style={{
                                marginRight: "8px",
                                color: "#a94442",
                                fontSize: "18px",
                                verticalAlign: "middle"
                            }}
                        />
                    </span>
                    <span className="visually-hidden">Error: </span>
                    Data is temporarily unavailable at the moment, please try again later.
                    We apologise for any inconvenience caused.
                </div>
            </div>
        );
    };

    render() {
        const { unitPricesData, errorMessageShow } = this.state;
        const tableDataMap = this.getTableData();
        const formattedDateTime = this.getFormattedDate();

        return (
            <div className="bootstrap3-layout">
                <div className="container">
                    <h1 className="header1">Current Unit Prices – {formattedDateTime}</h1>

                    {this.renderErrorMessage()}

                    <DownloadMenu
                        reportName={this.props.reportName}
                        show={!errorMessageShow && unitPricesData.length > 0}
                    />

                    {tableDataMap.map((item) => (
                        <LastUnitPricesTable
                            key={item.tableHeader}
                            header={item.tableHeader}
                            tableData={item.tableData}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default UnitPricesPage;
